import { render } from "./NewsCenter.vue?vue&type=template&id=41ba2520&scoped=true"
import script from "./NewsCenter.vue?vue&type=script&lang=js"
export * from "./NewsCenter.vue?vue&type=script&lang=js"

import "./NewsCenter.vue?vue&type=style&index=0&id=41ba2520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41ba2520"]])

export default __exports__